<template>
	<div id="bkcollect" style="margin-top:-20px;">
		<div class="g-right-middle width800 bkcollect">
			<ul style="margin-left: -8px;">
				<li v-for="(item,key) in list" :key="item.id">
					<router-link :to="'/baikecontent/'+item.collect_perf.id">
						<img :src='item.collect_perf.picture' width="100%" height="auto" />
					</router-link>
					<div class="">
						<div class="float-left" style="width:150px;margin-top: 10px;margin-left: 10px;">{{item.collect_perf.name}}</div>
						<span @click="del(key,item.id)" class="el-icon-delete float-right"></span>
						<div class="clearfix"></div>
					</div>
				</li>
				<div class="clearfix"></div>
			</ul>
		</div>
	</div>
</template>
<script>
	import storage from '../../../storage/storage.js'
	import Axios from 'axios'
	export default {
		data() {
			return {
				list: []
			}
		},

		methods: {
			collect() {
				var api = 'https://api.yopoo.cn/api/centre/getcollect?page=1&count=12&state=1'
				let token = storage.get('token')
				Axios.get(api, {
					headers: {
						'Authorization': token
					}
				}).then((res) => {

					this.list = res.data
				}).catch()

			},
			del(key, id) {
				this.$Modal.confirm({
					title: '警告！',
					content: '确认删除？',
					onOk: () => {
						var api = 'https://api.yopoo.cn/api/centre/delecollect?id=' + id
						let token = storage.get('token')
						Axios.get(api, {
							headers: {
								'Authorization': token
							}
						}).then((res) => {
								if (res.data.code == 200) {
									this.$message({
										message: res.data.msg,
										type: 'success',
										center: true

									});
									this.list.splice(key, 1) //实际删除内容的索引，删除后页面会刷新删除后的内容，但是实际上没有执行对后台的删除动作
									this.list.splice(id, 1) //实际删除内容的后台id,但删除的内容是key,而且页面不会刷新显示删除的内容

								}
								if (res.data.code == 202)
									this.$message({
										message: res.data.msg,
										type: 'error',
										center: true

									});
							},
							(err) => {
								console.log(err)
							})

					},
					onCancel: () => {
						// this.$Message.info('点击了取消');
					}
				})



			}

		},
		mounted() {
			this.collect()
		}
	}
</script>
<style>

</style>



// WEBPACK FOOTER //
// src/components/group_admin/collect/G_BkCollect.vue